//
// Pre-Injector
//

PreInjector = function (ruleDefinitions, creationCallbacks) {
  this.base = new Injector();
  this.base.initialise(
    ruleDefinitions.rules,
    ruleDefinitions.symbolWeights,
    creationCallbacks
  );

  var _minimumSymbols = -1;
  var _symbolsSpun = -1;
  var _spliceRequested = false;
  var _forceStop = false;
  var _stateData = {};

  this.saveState = function () {
    // Save state
    _stateData = {};
    var keys = Object.getOwnPropertyNames(this);
    for (var i = 0; i < keys.length; i++) {
      var name = keys[i];
      var type = typeof this[name];
      var isCallback = name.includes("callback") || name.includes("Callback");

      if (type !== "function" && name !== "base" && !isCallback) {
        if (checkForDefined(this[name])) {
          _stateData[keys[i]] = JSON.parse(JSON.stringify(this[name]));
        } else {
          _stateData[keys[i]] = undefined;
        }
      }
    }

    // Add the local scope variables above
    _stateData._minimumSymbols = checkForDefined(_minimumSymbols)
      ? JSON.parse(JSON.stringify(_minimumSymbols))
      : undefined;
    _stateData._symbolsSpun = checkForDefined(_symbolsSpun)
      ? JSON.parse(JSON.stringify(_symbolsSpun))
      : undefined;
    _stateData._spliceRequested = checkForDefined(_spliceRequested)
      ? JSON.parse(JSON.stringify(_spliceRequested))
      : undefined;
    _stateData._forceStop = checkForDefined(_forceStop)
      ? JSON.parse(JSON.stringify(_forceStop))
      : undefined;
  };

  this.restoreState = function () {
    var keys = Object.keys(_stateData);
    for (var i = 0; i < keys.length; i++) {
      var name = keys[i];
      if (checkForDefined(_stateData[name])) {
        this[name] = JSON.parse(JSON.stringify(_stateData[name]));
      } else {
        this[name] = undefined;
      }
    }
    _stateData = {};
  };

  this.initialiseInjector = function (initData) {
    //var initData = {
    //	reelId,
    //	minimumSymbols,
    //	spinReversed,
    //	requiredSymbols,
    //	symbolsLastDrawn
    //};
    this.base.reelId = initData.reelId;
    this.base.requiredSymbols = initData.requiredSymbols.slice();
    this.base.spinReversed = initData.spinReversed;
    this.symbolsLastDrawn = initData.symbolsLastDrawn;

    _minimumSymbols = initData.minimumSymbols;
    _symbolsSpun = 0;
    _spliceRequested = false;
    _forceStop = false;
  };

  this.prepareToSplice = function () {
    _spliceRequested = true;
  };

  this.forceStop = function () {
    _forceStop = true;
  };

  this.getNextSymbol = function (symbolData) {
    ++_symbolsSpun;

    if (this.base.spinReversed) {
      return this.base.getValidSymbol(
        symbolData,
        [],
        _spliceRequested && this.canStop ? 0 : -1
      );
    } else {
      return this.base.getValidSymbol(
        [],
        symbolData,
        _spliceRequested && this.canStop ? 0 : -1
      );
    }
  };

  this.getSymbolChildData = function (symbolId) {
    return this.base.getSymbolChildData(symbolId);
  };

  Object.defineProperty(this, "canStop", {
    get: function () {
      return _symbolsSpun >= _minimumSymbols || _forceStop;
    },
  });

  Object.defineProperty(this, "minimumSymbols", {
    get: function () {
      return _minimumSymbols;
    },
  });

  Object.defineProperty(this, "symbolsLastDrawn", {
    get: function () {
      return this.base.symbolsLastDrawn;
    },
    set: function (symbols) {
      var keys = Object.keys(symbols);
      for (var i = 0; i < keys.length; ++i) {
        this.base.symbolsLastDrawn[keys[i]] = symbols[keys[i]];
      }
    },
  });

  Object.defineProperty(this, "requiredSymbols", {
    get: function () {
      return this.base.requiredSymbols;
    },
    set: function (symbols) {
      this.base.requiredSymbols = symbols;
    },
  });
};
